import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ServiceLevelDemoService {

  private _emailServiceLevelContext: IServiceLevel;
  private _phoneServiceLevelContext: IServiceLevel;

    constructor() { 
      this._phoneServiceLevelContext = {
        Name: "name",
        Location: "",
        LastUpdated: "",
        Items: [
          { Name: 'Skillset 1', ServiceLevel: "72%", DelayedAnswerLevel: "27%", Priority: 1, WarningLevel: 1 },
          { Name: 'Skillset 2', ServiceLevel: "77%", DelayedAnswerLevel: "23%", Priority: 1, WarningLevel: 1 },
          { Name: 'Skillset 3', ServiceLevel: "33%", DelayedAnswerLevel: "67%", Priority: 2, WarningLevel: 2 },
          { Name: 'Skillset 4', ServiceLevel: "34%", DelayedAnswerLevel: "66%", Priority: 2, WarningLevel: 2 },
          { Name: 'Skillset 5', ServiceLevel: "50%", DelayedAnswerLevel: "50%", Priority: 3, WarningLevel: 1 },
          { Name: 'Skillset 6', ServiceLevel: "80%", DelayedAnswerLevel: "18%", Priority: 3, WarningLevel: 0 },
          { Name: 'Skillset 7', ServiceLevel: "90%", DelayedAnswerLevel: "10%", Priority: 3, WarningLevel: 0 }
        ]
      };

      this._emailServiceLevelContext = {
        Name: "name",
        Location: "",
        LastUpdated: "",
        Items: [
          { Name: 'Skillset 10', ServiceLevel: "51%", DelayedAnswerLevel: "48%", Priority: 1, WarningLevel: 1 },
          { Name: 'Skillset 20', ServiceLevel: "57%", DelayedAnswerLevel: "43%", Priority: 1, WarningLevel: 1 },
          { Name: 'Skillset 30', ServiceLevel: "33%", DelayedAnswerLevel: "67%", Priority: 2, WarningLevel: 2 },
          { Name: 'Skillset 40', ServiceLevel: "38%", DelayedAnswerLevel: "76%", Priority: 2, WarningLevel: 2 },
          { Name: 'Skillset 50', ServiceLevel: "40%", DelayedAnswerLevel: "60%", Priority: 2, WarningLevel: 2 },
          { Name: 'Skillset 60', ServiceLevel: "85%", DelayedAnswerLevel: "15%", Priority: 3, WarningLevel: 0 },
          { Name: 'Skillset 70', ServiceLevel: "98%", DelayedAnswerLevel: "2%", Priority: 3, WarningLevel: 0 }
        ]
      };
    }
  
    get(view: string) {
      return of(view === "serviceLevelEmail" ? this._emailServiceLevelContext : this._phoneServiceLevelContext);
    }
  }

  export interface IServiceLevel {
    Name: string,
    Location: string,
    LastUpdated: string,
    Items: ISLItem[]
  }

  interface ISLItem {
    Name: string,
    ServiceLevel: string,
    DelayedAnswerLevel: string,
    Priority: number,
    WarningLevel: number
  }

